module.exports = __webpack_public_path__ + "img/logo-menu.0df9ec13.png";